import React from "react";

const STORE = {
  name: "Jaggi Sweets",
  tagline: "Official Billing & POS System",
  footer: [
    "Thank you for shopping at Jaggi Sweets!",
    "Visit Again!",
    "Customer Care: +91 9XXXXXXXXX",
    "GSTIN: XXAAAA0000X",
    "Software by Jaggi Tech",
  ],
};

export default function BillReceipt({ bill }) {
  if (!bill) return null;

  return (
    <div
      id="searchReceipt"
      className="w-[320px] bg-white text-black p-3 font-mono text-xs"
    >
      <div className="text-center font-bold text-lg">
        {STORE.name}
      </div>

      <div className="text-center">
        {STORE.tagline}
      </div>

      <hr className="my-2" />

      <div>Bill No : {bill.bill_no}</div>

      <div>Token : {bill.token_no}</div>

      <div>Payment : {bill.payment_mode}</div>

      <div>
        Date :
        {bill.created_at
          ? new Date(bill.created_at).toLocaleString()
          : "-"}
      </div>

      <hr className="my-2" />

      <div className="font-bold text-center mb-2">
        ITEMS
      </div>

      {bill.items.map((item, index) => (
        <div
          key={index}
          className="flex justify-between"
        >
          <span>
            {item.name} x {item.qty}
          </span>

          <span>
            ₹{item.amount.toFixed(2)}
          </span>
        </div>
      ))}

      <hr className="my-2" />

      <div className="flex justify-between">
        <span>Total</span>

        <span>₹{bill.grand_total.toFixed(2)}</span>
      </div>

      {bill.remarks && (
        <>
          <hr className="my-2" />

          <div>{bill.remarks}</div>
        </>
      )}

      <hr className="my-2" />

      {STORE.footer.map((f, i) => (
        <div
          key={i}
          className="text-center text-[10px]"
        >
          {f}
        </div>
      ))}
    </div>
  );
}